<template>
  <div
    class="colorScreen_container"
    :style="{ marginTop: customerId == 58 ? '226px' : '0px' }"
  >
    <div class="carInfo" v-show="item_car && subRoadMapType == '3d'">
      <div class="typeName">{{ carInfoBox(item_car) }}</div>
      <div class="typeName2" v-if="item_car.todayDistance !== '0.00'">
        正在清扫<span>{{ item_car.road_name }}</span>
      </div>
      <div class="typeName2" v-else>
        车辆在<span>{{ item_car.road_name }}</span>
      </div>
      <div class="typeName2" v-if="item_car.todayDistance !== '0.00'">
        今日已清扫<span>{{ item_car.todayDistance }}</span
        >公里
      </div>
      <div class="typeName2" v-else>今日无清扫数据</div>
    </div>
    <div class="colorScreen_inner" v-show="subRoadMapType == '2d'">
      <div class="mapAll">
        <div
          :class="{
            bg: customerId == 42 ? true : false,
            bg_58: customerId == 58 ? true : false,
            bg_89: customerId == 89 ? true : false,
          }"
        ></div>
        <div v-if="customerId == 42">
          <div class="door1"></div>
          <div class="door2"></div>
          <div class="door3"></div>
          <div class="door4"></div>
          <div class="door5"></div>
        </div>
        <div
          :class="{
            mapContainer: customerId == 42 ? true : false,
            map58Container: customerId == 58 ? true : false,
            map89Container: customerId == 89 ? true : false,
          }"
        >
          <template v-for="(item, i) in roadArr_" :key="i">
            <myRoad
              @handler-carMission="handlerCarMission"
              :roadWidth="item.width"
              :roadTop="item.top"
              :roadLeft="item.left"
              :roadRotate="item.rotate"
              :roadHasCar="item.roadHasCar"
              :startLnd="item.startLnd"
              :startLat="item.startLat"
              :endLnd="item.endLnd"
              :endLat="item.endLat"
              :todayDistance="item.todayDistance"
              :carInfo="item.carInfo"
              :currentRoad="roadData"
              :currentRoadInfo="roadInfoList"
              :otherRoadInfo="otherRoadInfo"
              :roadId="item.model_id"
              :carCurrentID="carCurrentID"
              :roadHeight="item.height"
              :roadType="item.road_type"
              :roadName="item.road_name"
            ></myRoad>
          </template>
        </div>
      </div>

      <div class="cameraBlock" v-if="customerId == 42">
        <span>道路监控</span>
        <el-switch v-model="cameraShow"></el-switch>
      </div>

      <div class="mode3dBlock" v-if="customerId == 42">
        <span>三维道路</span>
        <el-switch v-model="mode3d"></el-switch>
      </div>

      <div v-if="customerId == 42">
        <template v-for="(item, i) in cameraList" v-bind:key="i">
          <div
            :style="{
              top: item.top + 'px',
              left: item.left + 'px',
              transform: item.transform,
            }"
            @click="
              (e) => {
                openVideoCamera(e, item);
              }
            "
            v-show="cameraShow"
            class="camera"
          >
            <span>{{ item.name }}</span>
          </div>
        </template>
      </div>

      <div
        class="mission-bar"
        ref="missionBar"
        :style="{ bottom: customerId == 58 ? '44%' : '35%' }"
        v-show="missionBarShow"
      >
        <div class="car-name">
          {{ curVehicleName
          }}<span v-if="curDriveName"> (司机 : {{ curDriveName }})</span
          ><span v-else>(当前司机未登录)</span>
        </div>
        <div>
          <el-select
            class="road-sel"
            size="medium"
            v-model="roadMission"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in roadArrSort(roadArr_)"
              :key="item.model_id"
              :label="item.road_name"
              :value="item.road_name"
            >
              <div style="float: left; margin-right: 15px">
                {{ item.road_name }}
              </div>
              <template v-if="item.riskLevel == 1">
                <div style="float: right">
                  <p class="roadLevel-star"></p>
                </div>
              </template>
              <template v-if="item.riskLevel == 2">
                <div style="float: right">
                  <p class="roadLevel-star"></p>
                  <p class="roadLevel-star"></p>
                </div>
              </template>
              <template v-if="item.riskLevel == 3">
                <div style="float: right">
                  <p class="roadLevel-star"></p>
                  <p class="roadLevel-star"></p>
                  <p class="roadLevel-star"></p>
                </div>
              </template>
            </el-option>
          </el-select>

          <a class="mission-send" @click="makeCarRecord()">调派</a>
        </div>
        <div class="phone-call" @click="makePhoneCall()">
          <p class="phone-call-icon"></p>
          {{ "拨打电话" }}
        </div>
      </div>

      <DriversMod
        :cleanCars="cleanCars"
        v-show="cleanCarShow"
        class="drivers-mode"
        @oneDriver-click="oneDriverClick"
        ref="driversMod"
      ></DriversMod>

      <div
        v-if="agoraStatus"
        ref="agoraRTC_localVideoBar"
        class="agoraRTC-localVideoBar"
      ></div>

      <div
        v-if="agoraStatus"
        ref="agoraRTC_remoteVideoBar"
        class="agoraRTC-remoteVideoBar"
      ></div>

      <div v-if="agoraStatus && isCalling" class="call_bar">
        <div class="call_bar_bg"></div>
        <div class="call_name">{{ callPerson }}</div>
        <div class="call_icon phoneCall_animate" @click="callDown()">
          <div class="call_txt">呼叫中</div>
        </div>
      </div>

      <!-- 左：天气盒子 -->
      <div class="weatherBar" v-show="customerId == 42 ? true : false">
        <div
          class="weatherBox"
          v-for="(item, index) in wbList"
          :key="item"
          :class="index == 3 && 'weatherBox2'"
        >
          <div class="wbItem">
            <div class="wbTitle">{{ item[0].name }}</div>
            <div class="wbValue">
              <div class="number">{{ getValue(item[0].valueID) }}</div>
              <div>
                {{ getUnit(item[0].valueID) || item[0].baseUnit }}
              </div>
            </div>
          </div>
          <div class="wbItem">
            <div class="wbTitle">{{ item[1].name }}</div>
            <div class="wbValue">
              <div class="number">{{ getValue(item[1].valueID) }}</div>
              <div>
                {{ getUnit(item[1].valueID) || item[1].baseUnit }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左二：道路 -->
      <div
        class="roadLegend"
        :style="{ bottom: customerId == 58 ? '5%' : '15%' }"
      >
        <div class="rlItem Diary">
          <div class="rlcolor"></div>
          <div class="rltitle" v-if="customerId == 58">中等</div>
          <div class="rltitle" v-else>中度污染</div>
        </div>
        <div class="rlItem ligthDiary">
          <div class="rlcolor"></div>
          <div class="rltitle" v-if="customerId == 58">良好</div>
          <div class="rltitle" v-else>轻度污染</div>
        </div>
        <div class="rlItem clean">
          <div class="rlcolor"></div>
          <div class="rltitle" v-if="customerId == 58">优秀</div>
          <div class="rltitle" v-else>&nbsp;&nbsp;&nbsp;无污染</div>
        </div>
      </div>
      <!-- 右：道路轮播 -->
      <div
        class="roadTooltips"
        :style="{ top: customerId == 58 ? '-8%' : '2%' }"
      >
        <div class="roadItem roadBox" v-for="(item, idx) in 4" :key="idx">
          <div class="rttTop">
            <div class="road-idx">
              {{ getRoadIdx(roadInfoList[idx] && roadInfoList[idx].modelId) }}
            </div>
            <div>道路名称</div>
            <div>
              {{
                roadInfoList[idx] && roadInfoList[idx].roadName
                  ? roadInfoList[idx].roadName
                  : "--"
              }}
            </div>
          </div>
          <div class="rttBottom">
            <div>道路分级展示：</div>
            <div
              :class="[
                {
                  Diary:
                    roadInfoList[idx] && roadInfoList[idx].riskLevel == '1',
                },
                {
                  ligthDiary:
                    roadInfoList[idx] && roadInfoList[idx].riskLevel == '2',
                },
                {
                  clean:
                    roadInfoList[idx] && roadInfoList[idx].riskLevel == '3',
                },
              ]"
            >
              {{
                roadInfoList[idx] && roadInfoList[idx].riskLevel == "1"
                  ? customerId == 58
                    ? "中等"
                    : "中度污染"
                  : roadInfoList[idx] && roadInfoList[idx].riskLevel == "2"
                  ? customerId == 58
                    ? "良好"
                    : "轻度污染"
                  : roadInfoList[idx] && roadInfoList[idx].riskLevel == "3"
                  ? customerId == 58
                    ? "优秀"
                    : "&nbsp;&nbsp;&nbsp;无污染"
                  : "--"
              }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="roadVdm150"
        :class="item.class"
        v-for="(item, index) in vdm150List"
        :key="index"
        @click="openVdm(index)"
      ></div>

      <div
        class="vdmChart"
        v-for="(item, index) in vdm150List"
        :key="index"
        v-show="nowVdm == index && isShow"
      >
        <div class="vcTitle">{{ item.name }}</div>
        <div class="vcClose" @click="closeRoadVdm"></div>
        <SingleVdm
          v-if="nowVdm == index && isShow"
          :deviceNo="item.deviceNo"
          :startTime="timeArr[0]"
          :endTime="timeArr[1]"
        />
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  RealTimeCleanCarStartFunc,
  IsShowBoidsFunc,
  IsShowBuildingsFunc,
  IsShowTargetFunc,
  StopPathFunc,
  LoadPathFromJSFunc,
  RoadHeatLineFunc,
  ShowHeatLineFunc,
} from "@/assets/js/unity3D/index.js";

import { roadDataList, road58DataList, road89DataList } from "./roadList.js";
import unityFly from "./unityFly.js";
import myRoad from "./components/myRoad/myRoad.vue";
import SingleVdm from "@/modules/unorganizedComponents/vdmBar/singleVdm.vue";
import chartLine3 from "@/modules/Charts/chartLine3";
import DriversMod from "./drivers.vue";
import cameraList from "./cameraList.js";
import iframePup from "@/modules/iframePup/iframePup.vue";
import { mapGetters } from "vuex";

import { dateFormat } from "@/utils/tools.js";
import { ElMessage } from "element-plus";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';

const AgoraRTM_appID = "9f0c0ef090024f749a5740297e93b2fb"; //"f327a799e9b34ae983e97c939d19c057";
const AgoraRTC_appID = "9f0c0ef090024f749a5740297e93b2fb";
const AgoraRTC_Token =
  "006594a3658b6ec4f599ce1f795f5551a65IAB++d0iHOKDmilLfbvcdrVOhSCgieGhC2kh5Fytv7m42GFGmVkAAAAAEAANcJk0wSKsYQEAAQDBIqxh";
const AgoraRTM_channelID = bmeConfig.loginName
  ? bmeConfig.loginName
  : "bme_xiaomei"; //"bme" + parseInt(Math.random() * 1000);
//http://localhost:9070/screen/agora/tokenByAccount?channelName=bme&userAccount=123456

const agoraRTC_Settings = {
  localAudioTrack: null,
  localVideoTrack: null,
  client: null,
};

const agoraRTC_Options = {
  // Pass your App ID here.
  appId: AgoraRTC_appID,
  // Set the channel name.
  channel: AgoraRTM_channelID,
  // Pass your temp token here.
  token: "",
  // Set the user ID.
  uid: 0,
};

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { myRoad, SingleVdm, chartLine3, DriversMod },
  props: {
    roadMapType: {
      type: String,
      required: false,
      default: "3d",
    },
    carNum: {
      type: String,
      required: false,
      default: "",
    },
    selCamera: {
      type: Object,
      required: false,
      default: "",
    },
    isShowType2D: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    //这里存放数据
    return {
      pageInfo: 'NewColorScreen.vue',
      computedName: '数字化道路2d地图组件',
      customerId: this.$store.state.customerId,
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      time: "",
      dataList: [],
      isFlyAround: false,
      isCtrl: false,
      roadList: [],
      roadData: [],
      roadInfoList: [],
      otherRoadInfo: [],
      roadArr: [],
      carCurrentID: [],
      timer5: null,
      timer6: null,
      timerTitleShow: null,
      carListArr: [],
      missionBarShow: false,
      sum: 0,
      tableDataJsonParse: [],
      roadMission: "",
      curVehicleName: "",
      curVehicleDutNum: "",
      curDriveName: "",
      curDriveAccount: "",
      roadStatus: [
        {
          status: "干燥",
          value: 100,
        },
        {
          status: "中等",
          value: 51,
        },
        {
          status: "湿润",
          value: 1,
        },
        // {
        //   status: null,
        //   value: 75,
        // },
      ],
      dataListShowTwo: [],
      currentRow: 1,
      wbList: [
        [
          {
            name: "PM10",
            valueID: 61,
            baseUnit: "μm/m³",
          },
          {
            name: "PM2.5",
            valueID: 62,
            baseUnit: "μm/m³",
          },
        ],
        [
          {
            name: "温度",
            valueID: 8,
            baseUnit: "℃",
          },
          {
            name: "湿度",
            valueID: 22,
            baseUnit: "%",
          },
        ],
        [
          {
            name: "风速",
            valueID: 65,
            baseUnit: "m/s",
          },
          {
            name: "风向",
            valueID: 63,
            baseUnit: "",
          },
        ],
        [
          {
            name: "降雨量",
            valueID: 600,
            baseUnit: "mm",
          },
          {
            name: "",
            valueID: "",
            baseUnit: "",
          },
        ],
      ],
      vdm150List: [
        {
          class: "pos1",
          deviceNo: "BMEVDM0J210501256",
          name: "西环路南段VDM-YCM",
        },
        {
          class: "pos2",
          deviceNo: "BMEVDM0J210501257",
          name: "白灰窑北路VDM-YCM",
        },
        {
          class: "pos3",
          deviceNo: "BMEVDM0J210501258",
          name: "西环路北段VDM-YCM",
        },
      ],
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      nowVdm: false,
      isShow: false,

      agoraRTM_Options: {
        uid: bmeConfig.loginName ? bmeConfig.loginName : "bme_xiaomei",
        token: "",
      },
      RTMclient: null,
      isCalling: false,
      callPerson: "",
      localInvitation: [],
      cleanCars: [],
      cleanCarShow: false,

      roadArr_: [],
      cameraList: [],

      cameraShow: false,
      cameraOpen: false,

      mode3d: false,

      subRoadMapType: "3d",
      carNumString: "",
      cleanerList: [],

      item_car: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    carInfoBox() {
      return (item) => {
        return `${item.dtuName}(${item.typeName})`;
      };
    },
    roadArrSort() {
      return (val) => {
        let newRoadArr = val.sort((a, b) => {
          return parseInt(a.riskLevel) - parseInt(b.riskLevel);
        });
        return newRoadArr;
      };
    },
    getValue() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].value;
      };
    },
    getUnit() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].unit;
      };
    },
    flyRoadData() {
      return unityFly.filter((i) => {
        return i.include.includes(this.roadData[0].modelId);
      });
    },
    getRoadIdx() {
      return function (modelId) {
        let idx = 0;
        idx = $.inArray(modelId, this.roadData);
        return idx + 1;
      };
    },
  },
  inject: ["updateRoadNvrInfoBox", "updateVideoType"],
  //监控data中的数据变化
  watch: {
    selCamera: {
      handler(newVal, oldVal) {
        setTimeout(() => {
          this.openVideoCamera("", newVal);
        }, 1500);
      },
      deep: true,
    },
    carNum: {
      handler(newVal, oldVal) {
        this.carNumString = newVal;
        if (newVal) {
          this.cleanerList.forEach((item) => {
            if (item.deviceNo == newVal) {
              this.item_car = item;
              let deviceName = "";
              if (item.deviceName.indexOf("_") >= 0) {
                deviceName = item.deviceName.split("_")[1];
              } else {
                deviceName = item.deviceName;
              }
              if (this.roadMapType === "3d") {
                this.openPup(
                  bmeConfig.baseUrl +
                    "/standard/vis/page/carSituation/carSituation.html?customerId=" +
                    this.customerId +
                    "&dtuName=" +
                    encodeURI(encodeURI(deviceName)) +
                    "&sourceType=1&style=typeDark" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '')
                    ,
                  () => {
                    this.$emit("closeVehicleDetail", true);
                  }
                );
              }
            }
          });
        } else {
          this.item_car = "";
          let that = this._.appContext.app;
          this.$popup.close(that, "specialPup_parent");
        }
      },
      deep: true,
    },
    roadMapType: {
      handler(newVal, oldVal) {
        this.subRoadMapType = newVal;
        if (newVal == "2d") {
          this.mode3d = false;
        }
      },
      deep: true,
    },
    mode3d: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$emit("change3dMap", true);
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.customerId == 42) {
      this.roadArr = roadDataList;
    } else if (this.customerId == 58) {
      this.roadArr = road58DataList;
    } else if (this.customerId == 89) {
      this.roadArr = road89DataList;
    }
    this.roadArr_ = $.extend(true, [], this.roadArr);
    // console.log("roadDataList", this.roadArr);
    this.cameraList = cameraList;

    if (this.customerId != 42) {
      this.vdm150List = [];
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //IsShowTargetFunc();
    this.agoraStatus = bmeConfig.needRTCandRTM
      ? bmeConfig.needRTCandRTM
      : false;
    if (this.agoraStatus) {
      /*this.reportListShow = true;
      this.$forceUpdate();
      this.getWorkTicketReport();*/
      this.INIT_RTM_RTC();
      this.startBasicCall();
    }
    document.addEventListener("click", this.handleDocumentClick);
    try {
      this.getTime();
      this.getCaronRoad();
      this.getData();
      this.getCarDataScoll();
      this.getData2();
      this.getData3();
    } catch (err) {
      console.log(err);
    }

    //IsShowBuildingsFunc();
    setTimeout(() => {
      IsShowBoidsFunc("true");
      IsShowTargetFunc("false");
    }, 500);

    // document.addEventListener("click", (e) => {
    //   console.log(e.target.className);
    //   if (e.target.className.includes("bg")) {
    //     this.isShow = false;
    //   }
    // });
  },
  unmounted() {
    document.removeEventListener("click", this.handleDocumentClick);
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer2) {
      clearTimeout(this.timer2);
    }
    if (this.timer3) {
      clearInterval(this.timer3);
    }
    if (this.timer5) {
      clearInterval(this.timer5);
    }
    if (this.timer6) {
      clearInterval(this.timer6);
    }
    if (this.timer7) {
      clearTimeout(this.timer7);
    }
    if (this.timer4) {
      clearTimeout(this.timer4);
    }
    if (this.timerTitleShow) {
      clearTimeout(this.timerTitleShow);
    }
  },
  async beforeUnmount() {
    await this.agoraRTC_LEAVE("", true);
  },
  //方法集合
  methods: {
    openPup(url, cb) {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: url,
        special: true,
        posLeft: -600,
        cb: cb,
      });
    },
    openVideoCamera(e, item) {
      e && e.stopPropagation();
      let obj = {
        left: "15%",
        top: "22%",
        scale: 0.8,
        width: "800px",
        height: "500px",
      };
      let videoObj = item;
      this.$store.commit("changeRoadVideoBoxSwitch", "open");
      this.cameraOpen = true;
      this.updateRoadNvrInfoBox(videoObj, obj);
    },
    closeVideoCamera() {
      this.$store.commit("changeRoadVideoBoxSwitch", "close");
      this.cameraOpen = false;
      //this.updateRoadNvrInfoBox("", "");
    },
    async INIT_RTM_RTC() {
      let that = this;
      let tokenResult = await this.getRTM_Token();
      console.log(tokenResult);
      this.agoraRTM_Options.token = tokenResult;

      let rtcUID = parseInt(Math.random() * 1000);
      agoraRTC_Options.uid = rtcUID;
      let rtcTokenResult = await this.getRTC_Token(rtcUID);
      agoraRTC_Options.token = rtcTokenResult;

      //声网云信令
      let AgoraRTM_client = AgoraRTM.createInstance(AgoraRTM_appID);
      this.RTMclient = AgoraRTM_client;

      AgoraRTM_client.on(
        "RemoteInvitationReceived",
        function (remoteInvitation) {
          console.log(remoteInvitation);

          let peerId = remoteInvitation.callerId;
          let peerName = "";
          let channelId = remoteInvitation._channelId;

          let mathRoadContainer = $(that.$refs.mathRoad_container);
          if (mathRoadContainer.find(".call_in_" + peerId).length == 0) {
            let callInDiv = $(
              "<div class='call_in call_in_" + peerId + "'></div>"
            );
            let callInName = $(
              "<span class='call_in_name'>" + peerName + "呼叫</span>"
            );
            let callInGet = $("<div class='call_in_get'></div>");
            let callDonwGet = $("<div class='call_in_down'></div>");
            callInDiv.css(
              "top",
              130 + mathRoadContainer.find(".call_in_" + peerId).length * 100
            );
            callInDiv.append(callInName);

            callInDiv.append(callDonwGet);
            callInDiv.append(callInGet);
            callInGet.unbind("click");
            callInGet.bind("click", () => {
              if (that.getRemoteContactWin() >= 3) {
                ElMessage.error("最多支持3路视频通道!");
                return;
              }
              callInDiv.remove();
              remoteInvitation.accept();
              that.agoraRTC_JOIN();
              if (ParseRoamFunc) {
                ParseRoamFunc();
              }
            });
            callDonwGet.unbind("click");
            callDonwGet.bind("click", () => {
              console.log(remoteInvitation);
              callInDiv.remove();
              remoteInvitation.refuse();
            });
            mathRoadContainer.append(callInDiv);
          }

          remoteInvitation.on("RemoteInvitationRefused", (newState, reason) => {
            console.log("reason", reason);
            if (mathRoadContainer.find(".call_in_" + peerId).length > 0) {
              mathRoadContainer.find(".call_in_" + peerId).remove();
            }
          });

          /*if ($(that.$refs.agoraRTC_remoteVideoBar).children().length >= 3) {
          ElMessage.error("最多支持3路视频通道!");
          return;
        }
        remoteInvitation.accept();
        if (ParseRoamFunc) {
          ParseRoamFunc();
        }
        that.agoraRTC_JOIN();*/
          //that.agoraRTM_call(peerId, peerName);
        }
      );
      // 客户端事件监听
      // 显示对端发送的消息
      AgoraRTM_client.on("MessageFromPeer", function (message, peerId) {
        console.log("Message from: " + peerId + " Message: " + message);
      });
      // 显示连接状态变化
      AgoraRTM_client.on("ConnectionStateChanged", function (state, reason) {
        console.log("State changed To: " + state + " Reason: " + reason);
      });

      let AgoraRTM_channel = AgoraRTM_client.createChannel(AgoraRTM_channelID);
      AgoraRTM_channel.on("ChannelMessage", function (message, memberId) {
        console.log(
          "Message received from: " + memberId + " Message: " + message
        );
      });
      // 显示频道
      AgoraRTM_channel.on("MemberJoined", function (memberId) {
        console.log(memberId + " joined the channel");
      });
      // 频道成员
      AgoraRTM_channel.on("MemberLeft", function (memberId) {
        console.log(memberId + " left the channel");
      });
      this.getAgoraRTM_loginJoin(AgoraRTM_client, AgoraRTM_channel);
      $(".s_fiter").find(".s_txt").unbind("keypress");
      $(".s_fiter")
        .find(".s_txt")
        .bind("keypress", () => {
          if (event.keyCode == 13) {
            let contentVal = $(".s_fiter").find(".s_txt").val();
            this.getTranslateFunc(contentVal);
          }
          //this.agoraRTM_sendMsg(AgoraRTM_client, "测试内容", "ruifeng_admin");
          //this.agoraRTM_call(AgoraRTM_client, "ruifeng_admin");
        });

      //agoraRTC_Options.uid = parseInt(Math.random() * 10000);
      //
    },
    async getRTC_Token(userAccount) {
      let that = this;
      let getTokenByAccountFunc =
        CONFIG.requestName + that.$apiOpt.tokenByAccount;
      let result = await that.$apiUtils.get(getTokenByAccountFunc, {
        channelName: AgoraRTM_channelID,
        userAccount: userAccount,
      });
      return result;
    },
    async getRTM_Token() {
      let that = this;
      let getTokenRtmByUserIdFunc =
        CONFIG.requestName + that.$apiOpt.tokenRtmByUserId;
      let result = await that.$apiUtils.get(getTokenRtmByUserIdFunc, {
        userId: this.agoraRTM_Options.uid,
      });
      return result;
    },
    async callDown() {
      this.isCalling = false;
      this.$forceUpdate();
      this.localInvitation.forEach((item) => {
        item.val && item.val.cancel();
      });
      this.localInvitation = [];
      //this.localInvitation && this.localInvitation.cancel();
      //await this.agoraRTC_LEAVE();
    },
    async agoraRTC_JOIN() {
      let that = this;

      console.log(agoraRTC_Options);
      await agoraRTC_Settings.client.join(
        agoraRTC_Options.appId,
        agoraRTC_Options.channel,
        agoraRTC_Options.token,
        agoraRTC_Options.uid
      );
      // Create a local audio track from the audio sampled by a microphone.
      agoraRTC_Settings.localAudioTrack =
        await AgoraRTC.createMicrophoneAudioTrack();
      // Create a local video track from the video captured by a camera.
      //agoraRTC_Settings.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
      // Publish the local audio and video tracks to the RTC channel.
      await agoraRTC_Settings.client.publish([
        agoraRTC_Settings.localAudioTrack,
        //agoraRTC_Settings.localVideoTrack,
      ]);
      // Dynamically create a container in the form of a DIV element for playing the local video track.
      const localPlayerContainer = document.createElement("div");
      // Specify the ID of the DIV container. You can use the uid of the local user.
      localPlayerContainer.id = agoraRTC_Options.uid;
      localPlayerContainer.textContent = "Local user " + agoraRTC_Options.uid;
      localPlayerContainer.style.width = "420px";
      localPlayerContainer.style.height = "320px";
      $(that.$refs.agoraRTC_localVideoBar).append(localPlayerContainer);
      $(that.$refs.agoraRTC_localVideoBar).show();

      // Play the local video track.
      // Pass the DIV container and the SDK dynamically creates a player in the container for playing the local video track.
      agoraRTC_Settings.localVideoTrack &&
        agoraRTC_Settings.localVideoTrack.play(localPlayerContainer);
      console.log("publish success!");
    },
    async agoraRTM_leave_CN(name) {
      let peerId = "";
      let childAccount = await this.getChildAccount(name);
      console.log(childAccount);
      this.callPerson = childAccount.name ? childAccount.name : name;
      let listSon = childAccount.listSon;
      listSon.push({
        token: childAccount.account,
      });

      // 创建 LocalInvitation
      listSon.forEach((item) => {
        this.agoraRTC_LEAVE(item.token);
      });
    },
    async agoraRTC_LEAVE_CN(name) {
      let peerId = "";
      let childAccount = await this.getChildAccount(name);
      console.log(childAccount);
      this.callPerson = childAccount.name ? childAccount.name : name;
      let listSon = childAccount.listSon;
      listSon.push({
        token: childAccount.account,
      });

      // 创建 LocalInvitation
      listSon.forEach((item) => {
        this.agoraRTC_LEAVE(item.token);
      });
    },
    async agoraRTC_LEAVE(peerId, leaveAutoVision) {
      // Traverse all remote users.
      if (peerId) {
        let playerContainer = document.getElementById(peerId);
        playerContainer && playerContainer.remove();
        if (this.getRemoteContactWin() === 0) {
          // Destroy the local audio and video tracks.
          agoraRTC_Settings.localAudioTrack &&
            agoraRTC_Settings.localAudioTrack.close &&
            agoraRTC_Settings.localAudioTrack.close();
          agoraRTC_Settings.localVideoTrack &&
            agoraRTC_Settings.localVideoTrack.close &&
            agoraRTC_Settings.localVideoTrack.close();
          let playerContainer = document.getElementById(agoraRTC_Options.uid);
          playerContainer && playerContainer.remove();
          $(this.$refs.agoraRTC_localVideoBar).hide();

          $(this.$refs.agoraRTC_remoteVideoBar).hide();
          // Leave the channel.
          await agoraRTC_Settings.client.leave();
        }
      } else {
        // Destroy the local audio and video tracks.
        agoraRTC_Settings.localAudioTrack &&
          agoraRTC_Settings.localAudioTrack.close &&
          agoraRTC_Settings.localAudioTrack.close();
        agoraRTC_Settings.localVideoTrack &&
          agoraRTC_Settings.localVideoTrack.close &&
          agoraRTC_Settings.localVideoTrack.close();
        let playerContainer = document.getElementById(agoraRTC_Options.uid);
        playerContainer && playerContainer.remove();
        $(this.$refs.agoraRTC_localVideoBar).hide();

        agoraRTC_Settings.client &&
          agoraRTC_Settings.client.remoteUsers &&
          agoraRTC_Settings.client.remoteUsers.forEach((user) => {
            // Destroy the dynamically created DIV containers.
            let playerContainer = document.getElementById(user.uid);
            playerContainer && playerContainer.remove();
          });
        $(this.$refs.agoraRTC_remoteVideoBar).hide();

        // Leave the channel.
        await agoraRTC_Settings.client.leave();
      }
    },
    async startBasicCall() {
      let that = this;
      // Create an AgoraRTCClient object.
      console.log(AgoraRTC);
      agoraRTC_Settings.client = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      agoraRTC_Settings.client.on("user-published", async (user, mediaType) => {
        this.isCalling = false;
        // Subscribe to the remote user when the SDK triggers the "user-published" event
        await agoraRTC_Settings.client.subscribe(user, mediaType);
        console.log("subscribe success");

        // If the remote user publishes a video track.
        if (mediaType === "video" && user && user.videoTrack) {
          // Get the RemoteVideoTrack object in the AgoraRTCRemoteUser object.
          const remoteVideoTrack = user.videoTrack;
          // Dynamically create a container in the form of a DIV element for playing the remote video track.
          /*const remotePlayerContainer = document.createElement("div");
          //const remotePlayerContainer = that.$refs.agoraRTC_videoBar;
          // Specify the ID of the DIV container. You can use the uid of the remote user.
          remotePlayerContainer.id = user.uid.toString();
          remotePlayerContainer.textContent = "通话中..."; //"呼叫用户 " + this.callPerson;
          remotePlayerContainer.style.width = "800px";
          remotePlayerContainer.style.height = "600px";
          $(remotePlayerContainer).attr("class", "contact-bar");
          $(that.$refs.agoraRTC_remoteVideoBar).append(remotePlayerContainer);
          $(that.$refs.agoraRTC_remoteVideoBar).show();
          that.isCalling = false;
          that.$forceUpdate();
          //document.body.append(remotePlayerContainer);*/

          const remotePlayerContainer = document.createElement("div");
          //const remotePlayerContainer = that.$refs.agoraRTC_videoBar;
          // Specify the ID of the DIV container. You can use the uid of the remote user.
          remotePlayerContainer.id = user.uid.toString(); //user.uid.toString();
          $(remotePlayerContainer).attr("class", "contact-bar");
          remotePlayerContainer.textContent = ""; //"呼叫用户 " + this.callPerson;
          remotePlayerContainer.style.width = "800px";
          remotePlayerContainer.style.height = "600px";
          $(this.$refs.agoraRTC_remoteVideoBar).append(remotePlayerContainer);
          let remoteList = $(this.$refs.agoraRTC_remoteVideoBar).children();
          if (remoteList.length == 1) {
            //$(remotePlayerContainer).css("marginTop", "120px");
            $(remotePlayerContainer).addClass("videoPlayFirst");

            let playerContainerBtn = document.createElement("div");
            $(playerContainerBtn).attr("class", "playerContainerBtn");
            remotePlayerContainer.append(playerContainerBtn);
            $(playerContainerBtn).bind("click", () => {
              this.agoraRTC_LEAVE(user.uid.toString());
            });
          } else if (remoteList.length == 2) {
            $(remotePlayerContainer).css("marginTop", "-180px");
            $(remotePlayerContainer).css("marginLeft", "1000px");
            let playerContainerBtn = document.createElement("div");
            $(playerContainerBtn).attr("class", "playerContainerBtn");
            remotePlayerContainer.append(playerContainerBtn);
            $(playerContainerBtn).bind("click", () => {
              this.agoraRTC_LEAVE(user.uid.toString());
            });
          } else if (remoteList.length == 3) {
            $(remotePlayerContainer).css("marginTop", "-180px");
            $(remotePlayerContainer).css("marginLeft", "-1000px");
            let playerContainerBtn = document.createElement("div");
            $(playerContainerBtn).attr("class", "playerContainerBtn");
            remotePlayerContainer.append(playerContainerBtn);
            $(playerContainerBtn).bind("click", () => {
              this.agoraRTC_LEAVE(user.uid.toString());
            });
          }
          $(this.$refs.agoraRTC_remoteVideoBar).show();

          // Play the remote video track.
          // Pass the DIV container and the SDK dynamically creates a player in the container for playing the remote video track.
          remoteVideoTrack.play(remotePlayerContainer);

          // Or just pass the ID of the DIV container.
          // remoteVideoTrack.play(playerContainer.id);
        }

        // If the remote user publishes an audio track.
        if (mediaType === "audio" && user && user.audioTrack) {
          // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
          const remoteAudioTrack = user.audioTrack;
          // Play the remote audio track. No need to pass any DOM element.
          remoteAudioTrack.play();
        }

        // Listen for the "user-unpublished" event
        agoraRTC_Settings.client.on("user-unpublished", (user) => {
          // Get the dynamically created DIV container.
          if (!user._audioTrack && !user._videoTrack) {
            this.agoraRTC_LEAVE(user.uid);
          }
          /*const remotePlayerContainer = document.getElementById(user.uid);
          // Destroy the container.
          if (remotePlayerContainer && remotePlayerContainer.remove) {
            remotePlayerContainer.remove();
          }
          $(that.$refs.agoraRTC_remoteVideoBar).hide();

          const playerContainer = document.getElementById(agoraRTC_Options.uid);
          playerContainer && playerContainer.remove();
          $(that.$refs.agoraRTC_localVideoBar).hide();*/
        });
      });

      // Listen for the "user-published" event, from which you can get an AgoraRTCRemoteUser object.
    },
    async getAgoraRTM_loginJoin(client, channel) {
      await client.login(this.agoraRTM_Options);
      await channel.join().then(() => {
        console.log(
          "You have successfully joined channel " + channel.channelId
        );
      });
    },
    async agoraRTM_sendMsg(client, peerMessage, peerId) {
      await client
        .sendMessageToPeer({ text: peerMessage }, peerId)
        .then((sendResult) => {
          if (sendResult.hasPeerReceived) {
            console.log(
              "Message has been received by: " +
                peerId +
                " Message: " +
                peerMessage
            );
          } else {
            console.log(
              "Message sent to: " + peerId + " Message: " + peerMessage
            );
          }
        });
    },
    async getChildAccountApp(peerId) {
      let findUserAccountAppUrl =
        CONFIG.requestName + this.$apiOpt.findUserAccountApp;
      let result = await this.$apiUtils.get(findUserAccountAppUrl, {
        account: peerId,
      });
      return result;
    },
    async agoraRTM_call(peerId, name) {
      if (this.getRemoteContactWin() >= 3) {
        ElMessage.error("最多支持3路视频通道!");
        return;
      }
      this.isCalling = true;
      //this.callPerson = name;
      this.$forceUpdate();

      let childAccount = await this.getChildAccountApp(peerId);
      console.log(childAccount);
      this.callPerson = childAccount.name ? childAccount.name : name;

      let listSon = childAccount.listSon;

      listSon.push({
        token: peerId,
      });

      let that = this;

      listSon.forEach((item) => {
        // 创建 LocalInvitation
        let localInvitation = this.RTMclient.createLocalInvitation(item.token);
        this.localInvitation.push({
          key: item.token,
          val: localInvitation,
        });
        localInvitation.channelId = agoraRTC_Options.channel;

        // 发送呼叫邀请
        localInvitation.send();
        localInvitation.on("LocalInvitationAccepted", function (response) {
          console.log("Message received from:  Message: " + response);
          that.agoraRTC_JOIN();
        });

        localInvitation.on(
          "LocalInvitationRefused",
          function (newState, reason) {
            console.log("reason", reason);
            that.isCalling = false;
            that.$forceUpdate();
            if (that.getRemoteContactWin() === 0) {
              if (ContinueRoamFunc) {
                ContinueRoamFunc();
              }
            }
          }
        );
      });
    },
    async getChildAccount(name) {
      let findUserAccountUrl =
        CONFIG.requestName + this.$apiOpt.findUserAccount;
      let result = await this.$apiUtils.get(findUserAccountUrl, {
        name: name,
        customerId: this.customerId,
      });
      return result;
    },
    async agoraRTM_call_CN(name) {
      if (this.getRemoteContactWin() >= 3) {
        ElMessage.error("最多支持3路视频通道!");
        return;
      }
      let peerId = "";
      this.isCalling = true;
      //this.callPerson = name;
      this.$forceUpdate();

      let childAccount = await this.getChildAccount(name);
      console.log(childAccount);
      this.callPerson = childAccount.name ? childAccount.name : name;

      let listSon = childAccount.listSon;
      listSon.push({
        token: childAccount.account,
      });

      let that = this;
      // 创建 LocalInvitation
      listSon.forEach((item) => {
        let localInvitation = this.RTMclient.createLocalInvitation(item.token);
        //this.localInvitation = localInvitation;
        this.localInvitation.push({
          key: item.token,
          val: localInvitation,
        });
        localInvitation.channelId = agoraRTC_Options.channel;
        // 发送呼叫邀请
        localInvitation.send();
        localInvitation.on("LocalInvitationAccepted", function (response) {
          console.log("Message received from:  Message: " + response);
          that.agoraRTC_JOIN();
        });

        localInvitation.on(
          "LocalInvitationRefused",
          function (newState, reason) {
            console.log("reason", reason);
            that.isCalling = false;
            that.$forceUpdate();
            if (that.getRemoteContactWin() === 0) {
              if (ContinueRoamFunc) {
                ContinueRoamFunc();
              }
            }
          }
        );
      });
    },
    getRemoteContactWin() {
      let num = 0;
      if (
        this.$refs.agoraRTC_remoteVideoBar &&
        $(this.$refs.agoraRTC_remoteVideoBar) &&
        $(this.$refs.agoraRTC_remoteVideoBar).children() &&
        $(this.$refs.agoraRTC_remoteVideoBar).children().length
      ) {
        num = $(this.$refs.agoraRTC_remoteVideoBar).children().length;
      }
      return num;
    },
    makePhoneCall() {
      if (this.makePhoneCallTimer) {
        clearTimeout(this.makePhoneCallTimer);
      }
      this.makePhoneCallTimer = setTimeout(() => {
        if (this.curDriveAccount) {
          this.agoraRTM_call(this.curDriveAccount);
        } else {
          ElMessage({
            message: "无法拨通!",
            type: "error",
          });
        }
      }, 500);
    },
    makeCarRecord() {
      if (this.makeCarRecordTimer) {
        clearTimeout(this.makeCarRecordTimer);
      }
      this.makeCarRecordTimer = setTimeout(() => {
        if (this.curVehicleDutNum && this.roadMission) {
          this.carRecordSend(this.curVehicleDutNum, this.roadMission);
        }
      }, 500);
    },
    async carRecordSend(dtuNum, operationArea) {
      let carRecordUrl = CONFIG.requestNameRoad + this.$apiOpt.carRecord;
      let params = {
        customerId: this.customerId + "",
        dtuNum: dtuNum,
        operationArea: operationArea,
      };
      let result = await this.$apiUtils.get2(carRecordUrl, params);
      console.log(result);
      if (result.success && result.msg == "调度成功") {
        ElMessage({
          message: result.msg,
          type: "success",
        });
        this.missionBarShow = false;
      } else {
        ElMessage({
          message: result.msg,
          type: "errot",
        });
      }
    },
    oneDriverClick(msg) {
      if (this.missionBarShowTimer) {
        clearTimeout(this.missionBarShowTimer);
      }
      this.missionBarShowTimer = setTimeout(() => {
        this.cleanCarShow = false;
        this.roadMission = "";
        this.missionBarShow = true;
        this.curVehicleName = msg[0]["deviceName"];
        this.curVehicleDutNum = msg[0]["dtuNum"];
        this.curDriveName = msg[0]["driverName"];
        this.curDriveAccount = msg[0]["account"];
        let deviceName = "";
        if (this.curVehicleName.indexOf("_") >= 0) {
          deviceName = this.curVehicleName.split("_")[1];
        } else {
          deviceName = this.curVehicleName;
        }
        this.openPup(
          bmeConfig.baseUrl +
            "/standard/vis/page/carSituation/carSituation.html?customerId=" +
            this.customerId +
            "&dtuName=" +
            encodeURI(encodeURI(deviceName)) +
            "&sourceType=1&style=typeDark" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '')
        );
      }, 500);
    },
    handlerCarMission(msg) {
      if (this.missionBarShowTimer) {
        clearTimeout(this.missionBarShowTimer);
      }
      console.log(msg);
      if (msg.length > 1) {
        /*this.missionBarShowTimer = setTimeout(() => {
          this.missionBarShow = true;
          this.curVehicleName = msg[0]["deviceName"];
          this.curVehicleDutNum = msg[0]["dtuNum"];
          this.curDriveName = msg[0]["driverName"];
          this.curDriveAccount = msg[0]["account"];
        }, 500);*/
        this.missionBarShowTimer = setTimeout(() => {
          this.cleanCarShow = true;
          this.cleanCars = msg;
        }, 500);
      } else if (msg.length > 0) {
        this.missionBarShowTimer = setTimeout(() => {
          this.roadMission = "";
          this.missionBarShow = true;
          this.curVehicleName = msg[0]["deviceName"];
          this.curVehicleDutNum = msg[0]["dtuNum"];
          this.curDriveName = msg[0]["driverName"];
          this.curDriveAccount = msg[0]["account"];
          let deviceName = "";
          if (this.curVehicleName.indexOf("_") >= 0) {
            deviceName = this.curVehicleName.split("_")[1];
          } else {
            deviceName = this.curVehicleName;
          }
          this.openPup(
            bmeConfig.baseUrl +
              "/standard/vis/page/carSituation/carSituation.html?customerId=" +
              this.customerId +
              "&dtuName=" +
              encodeURI(encodeURI(deviceName)) +
              "&sourceType=1&style=typeDark" + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '')
          );
          /*if (this.customerId == 42) {
            // 调整框的位置
            $(".specialPup").css("transform", "scale(0.8) translate(-24%, 9%)");
          }*/
        }, 500);
      }
    },
    handleDocumentClick(e) {
      if (
        !this.missionBarShow ||
        !$(this.$refs.missionBar).is(":visible") ||
        $(this.$refs.missionBar).get(0).contains(e.target) ||
        ($(".contact-bar").length > 0 &&
          $(".contact-bar").get(0).contains(e.target))
      ) {
        // console.log(e.target, 'missionBarShow')
      } else {
        this.missionBarShow = false;
        let that = this._.appContext.app;
        if (this.customerId == 42) {
          this.$popup.close(that, "specialPup_parent");
        } else {
          this.$popup.close(that, "specialPup_parent");
        }
        //this.$store.commit("dialogStatus", false);
      }
      if (
        !this.cleanCarShow ||
        !$(this.$refs.driversMod.$el).is(":visible") ||
        $(this.$refs.driversMod.$el).get(0).contains(e.target)
      ) {
      } else {
        this.cleanCarShow = false;
      }

      if (
        !this.cameraOpen ||
        $(".mathRoad_container").find(".videoBox").get(0).contains(e.target)
      ) {
      } else {
        this.closeVideoCamera();
        this.cameraOpen = false;
      }
    },
    openVdm(itemIndex) {
      this.isShow = true;
      this.nowVdm = itemIndex;
    },
    closeRoadVdm() {
      this.isShow = false;
    },
    getData() {
      if (this.timer2) {
        clearTimeout(this.timer2);
      }
      //this.getSignalRealValue();
      this.getCaronRoad();
      this.timer2 = setTimeout(() => {
        this.getData();
      }, 1000 * 30);
    },
    getData3() {
      if (this.timer7) {
        clearTimeout(this.timer7);
      }
      this.getSignalRealValue();
      this.timer7 = setTimeout(() => {
        this.getData3();
      }, 1000 * 60 * 5);
    },
    getData2() {
      if (this.timer6) {
        clearTimeout(this.timer6);
      }
      this.getRoadData();
      this.timer6 = setTimeout(() => {
        this.getData2();
      }, 1000 * 60 * 20);
    },
    getTime() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        var time = new Date();
        var year = time.getFullYear(); //获取年份
        var month = time.getMonth() + 1; //获取月份
        var day = time.getDate(); //获取日期
        var hour = checkTime(time.getHours()); //获取时
        var minite = checkTime(time.getMinutes()); //获取分
        var second = checkTime(time.getSeconds()); //获取秒
        function checkTime(i) {
          if (i < 10) return "0" + i;
          return i;
        }
        var weeks = new Array(
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        );
        var dayNum = time.getDay();
        var week = weeks[dayNum];
        this.time = `${year}年${month}月${day}日 ${week} ${hour}:${minite}:${second}`;
      }, 1000);
    },
    //获取空气参数
    async getSignalRealValue() {
      const url = `${CONFIG.requestNameRoad}/digit/getSignalRealValue`;
      const res = await this.$apiUtils.get(url, {
        ledNo: "rf_rgb_led_1",
        customerId: this.customerId,
      });
      this.dataList = res || [];
      this.getShowData();
    },
    getShowData() {
      if (this.timerTitleShow) {
        clearTimeout(this.timerTitleShow);
      }
      this.currentRow++;
      if (this.currentRow > 4) {
        this.currentRow = 1;
      }
      this.timerTitleShow = setTimeout(() => {
        this.getShowData();
      }, 1000 * 5);
    },
    //获取65条道路状态
    async getRoadData(cb) {
      if (this.timer3) {
        clearInterval(this.timer3);
      }
      const url = `${CONFIG.requestNameRoad}/digit/roadList`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        roadId: null,
      });
      this.roadList = res || [];

      this.roadList.forEach((item) => {
        this.roadArr.forEach((item_) => {
          if (item.modelId === item_.model_id) {
            item_.startLat = item.startLat;
            item_.startLnd = item.startLnd;
            item_.endLat = item.endLat;
            item_.endLnd = item.endLnd;
            item_.riskLevel = item.riskLevel;
          }
        });
      });
      //生成所有路的json
      let AllJson = new Array(65);
      for (let i = 0; i < AllJson.length; i++) {
        AllJson[i] = { roadID: "42_" + (i + 1), value: 30 };
      }
      this.tableDataJsonParse = AllJson;
      let length = this.roadList.length;
      let i = 0;
      this.roadData = [];
      this.roadInfoList = [];
      let curIds = [];
      this.otherData = [];
      this.otherRoadInfo = [];
      try {
        for (let j = 0; j < 4; j++) {
          if (this.roadList[i + j]) {
            this.roadData.push(this.roadList[i + j]["modelId"]);
            this.roadInfoList.push(this.roadList[i + j]);

            curIds.push(i + j);
          }
        }

        for (let j = 0; j < length; j++) {
          if ($.inArray(j, curIds) < 0) {
            this.otherData.push(this.roadList[i + j]["modelId"]);
            this.otherRoadInfo.push(this.roadList[i + j]);
          }
        }
      } catch (err) {
        console.log(err);
      }

      let that = this;

      if (this.timer3) {
        clearInterval(this.timer3);
      }

      this.timer3 = setInterval(() => {
        // console.log(that.isFlyAround);
        if (!that.isFlyAround) {
          let roadBoxs = $(".roadBox");
          for (let n = 0; n < roadBoxs.length; n++) {
            that.roadTaskTurns(n, i, cb, that.roadList, function () {
              if (i < that.roadList.length) {
                i = i + 4;
              } else {
                i = 0;
              }
            });
          }
        }
      }, 15000);
    },
    roadTaskTurns(n, i, cb, res, cbFunc) {
      let length = res.length;
      let that = this;
      let roadBox = $(".roadBox").get(n);
      $(roadBox).animate({ opacity: "0" }, 1000, () => {
        if (n === 0) {
          // if (i < res.length) {
          //that.roadData = res[i];
          that.roadData = [];
          that.roadInfoList = [];

          let curIds = [];

          that.otherData = [];
          that.otherRoadInfo = [];
          try {
            for (let j = 0; j < 4; j++) {
              // console.log(i + j, (i + j) % length);
              if (res[i + j]) {
                that.roadData.push(res[i + j]["modelId"]);
                that.roadInfoList.push(res[i + j]);

                curIds.push(i + j);
              } else if (i + j > length) {
                that.roadData.push(res[(i + j) % length]["modelId"]);
                that.roadInfoList.push(res[(i + j) % length]);

                curIds.push(i + j);
              }
            }

            for (let j = 0; j < length; j++) {
              if ($.inArray(j, curIds) < 0) {
                that.otherData.push(res[j]["modelId"]);
                that.otherRoadInfo.push(res[j]);
              }
            }
          } catch (err) {
            console.log(err);
          }
          that.$forceUpdate();
          // } else {
          //   that.roadData = [];
          //   that.roadInfoList = [];
          //   i = 0;
          //   try {
          //     for (let j = 0; j < 4; j++) {
          //       if (res[i + j]) {
          //         that.roadData.push(res[i + j]["modelId"]);
          //         that.roadInfoList.push(res[i + j]);
          //       }
          //     }
          //   } catch (err) {
          //     console.log(err);
          //   }
          //   that.$forceUpdate();
          // }
          if (cbFunc) {
            cbFunc();
          }
        }
        // $(".roadBox").css({ opacity: "0", left: "0" });
        $(roadBox).animate({ opacity: "1" }, 1000, function () {
          if (n === 0) {
            cb && cb(); //数据更新的回调函数
            that.sum++;
            if (that.sum % 5 == 0) {
              if (that.flyRoadData?.length) {
                that.getLoadPathFromJSFunc();
              } else {
                that.sum--;
              }
            }
          }
        });
      });
    },
    //调取成都地图
    flyFunc() {
      console.log("this.roadData.modelId", this.roadInfoList[0].modelId);
      StopPathFunc();
      let roadJSON = "";
      roadJSON = this.flyRoadData[0].json;
      let arr = this.roadStatus.filter(
        (i) => i.status == this.roadInfoList[0].dryWetStatus
      );
      let dryWetValue;
      if (arr.length) {
        dryWetValue = arr[0].value;
        let obj2 = JSON.parse(JSON.stringify(this.tableDataJsonParse));
        let HLJson = obj2.map((item) => {
          if (item.roadID == this.roadInfoList[0].modelId) {
            item.value = dryWetValue;
            return item;
          } else {
            return item;
          }
        });
        RoadHeatLineFunc(JSON.stringify(HLJson));
        ShowHeatLineFunc();
      }
      console.log("lll", roadJSON);
      LoadPathFromJSFunc(roadJSON);
    },
    getLoadPathFromJSFunc() {
      // let that = this;
      // this.isFlyAround = true;
      // $(".mapContainer").animate({ opacity: 0 }, 1000, function () {
      //   $(".colorScreen_container").removeClass("bg");
      //   that.flyFunc();
      //   that.timer4 = setTimeout(() => {
      //     that.isFlyAround = false;
      //     $(".colorScreen_container").addClass("bg");
      //     $(".mapContainer").animate({ opacity: 1 }, 1000, function () {});
      //   }, 15000);
      // });
    },
    //获取有哪些车，并判断车在哪条路上
    async getCaronRoad() {
      const url = `${CONFIG.requestNameRoad}/digit/cleaner`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        dtuNum: null,
      });
      this.carListArr = [];
      this.roadArr.forEach((i) => {
        i.carInfo = [];
      });
      let n = 0;
      let totalObj = {};
      this.cleanerList = res;
      res.forEach((i) => {
        this.carListArr.push(i.deviceNo);
        this.roadArr.forEach((i_) => {
          if (i.roadModelId === i_.model_id) {
            i_.roadHasCar = true;
            let car = {
              dtuNum: i.dtuNum, //40910114055
              deviceName: i.deviceName, //洒水车_冀B2580S
              dtuName: i.dtuName, //冀B2580S
              typeName: i.typeName, //洒水车
              driverName: i.driverName,
              account: i.account,
              deviceNo: i.deviceNo,
              road_name: i_.road_name,
              todayDistance: i.todayDistance,
              isGPS: false,
              roadStartPointLatLng: i.roadStartPointLatLng,
              roadEndPointLatLng: i.roadEndPointLatLng,
              distanceRateFromSP: i.distanceRateFromSP,
              // isGPS: i.isGPS == "GPS已定位" ? true : false,
            };
            i_.carInfo.push(car);
            totalObj[i.deviceName] = i_.road_name;
            n++;
            i_.todayDistance = i.todayDistance
              ? parseFloat(i.todayDistance)
              : "";
          }
        });
      });
      let roadArr = $.extend(true, [], this.roadArr);
      this.roadArr_ = roadArr;
      console.log(n + "辆车");
      // console.log('车辆',this.roadArr);
    },
    //车辆信息弹窗轮播
    getCarDataScoll() {
      // console.log("this.roadArr", this.roadArr);
      if (this.timer5) {
        clearInterval(this.timer5);
      }
      this.carScrollTimer = 0;
      console.log("this.carListArr", this.carListArr);
      this.timer5 = setInterval(() => {
        this.carCurrentID = [];
        this.carCurrentID.push(this.carListArr[this.carScrollTimer]);
        this.carCurrentID.push(this.carListArr[this.carScrollTimer + 1]);
        this.carScrollTimer = this.carScrollTimer + 2;
        if (this.carScrollTimer >= this.carListArr.length) {
          this.carScrollTimer = 0;
        }
      }, 1000 * 5);
    },
  },
};
</script>
<style lang="scss">
.roadLevel-star {
  background-image: url("img/star.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 10px;
  height: 10px;
  margin: 0px 2px;
  display: inline-block;
}
.colorScreen_container {
  .drivers-mode {
    transform: rotate(270deg) scale(1.5);
    position: absolute;
    top: 40%;
    left: 24%;
    padding: 1px 20px;
    background-image: url(img/panelView_blackBg_2_3.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 25px !important;
    height: 600px;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
  }

  .agoraRTC-remoteVideoBar {
    position: absolute;
    height: 600px;
    width: 800px;
    top: 47%;
    left: 70%;
    transform: rotate(270deg);
    transform-origin: bottom left;
    z-index: 10000;
    pointer-events: none;
  }
  .contact-bar {
    background-image: url("img/contactBar.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 800px;
    height: 600px;
    padding: 20px;
    border-radius: 30px;
    overflow: hidden;
    position: absolute;
    pointer-events: all;

    .playerContainerBtn {
      background-image: url("img/endContact.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 346px;
      height: 66px;
      bottom: 50px;
      position: absolute;
      left: 230px;
      z-index: 999;
      pointer-events: all;
    }
  }

  .contact-bar > div {
    border-radius: 50px;
  }
  .agoraRTC-localVideoBar {
    position: absolute;
    z-index: 10000;
  }

  .call_bar {
    border-radius: 16px;
    overflow: hidden;
    position: absolute;
    background-image: url(img/call_outer.png);
    background-repeat: no-repeat;
    background-size: 500px 550px;
    background-position: -50px -25px;
    transform: rotate(270deg) scale(1.5);
    left: 25%;
    top: 42%;
    z-index: 10001;
    height: 510px;
    width: 400px;
    .call_bar_bg {
      border-radius: 16px;
      overflow: hidden;
      position: absolute;
      top: 160px;
      left: 110px;
      background: url(img/phone-icon_.png) no-repeat center center;
      height: 160px;
      width: 160px;
      background-size: 100% 100%;
      opacity: 0.7;
      background-repeat: no-repeat;
    }
    .call_name {
      position: absolute;
      width: 350px;
      top: 50px;
      left: 20px;
      text-align: center;
      font-size: 28px;
    }
    .call_icon {
      position: absolute;
      top: 400px;
      left: 85px;
      background: url(img/call_icon.png) no-repeat center center;
      height: 60px;
      width: 220px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      pointer-events: all;
      .call_txt {
        position: absolute;
        top: 10px;
        font-size: 26px;
        right: 50px;
        pointer-events: all;
      }
    }
  }
  .mission-bar {
    @include bg-box(907px, 421px, "mission.png");
    position: absolute;
    transform: rotate(-90deg);
    transform-origin: top left;
    bottom: 35%;
    right: -12%;
    z-index: 99;

    .car-name {
      font-size: 40px;
      color: #f4c48f;
      font-family: "fontNormal";
      line-height: 110px;
      text-align: center;
    }

    .road-sel {
      margin: 40px 40px;
      width: 550px;
      line-height: 65px;
      height: 65px;
      .el-input__inner {
        font-size: 34px;
      }
      .el-input__suffix {
        font-size: 34px;
      }
    }

    .mission-send {
      width: 215px;
      height: 60px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(img/send-btn1.png);
      background-size: 100% 100%;
      position: relative;
      display: inline-block;
      margin: -20px 0;
      text-align: center;
      font-size: 32px;
      color: #fff;
      font-family: "fontNormal";
      line-height: 60px;
      cursor: pointer;
    }
    .mission-send:hover {
      background-image: url(img/send-btn.png);
    }

    .phone-call {
      margin: 0px 40px;
      width: 820px;
      height: 120px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(img/call-btn1.png);
      background-size: 100% 100%;
      position: relative;
      display: inline-block;
      text-align: center;
      font-size: 42px;
      color: #fff;
      font-family: "fontNormal";
      line-height: 120px;
      cursor: pointer;

      .phone-call-icon {
        @include bg-box(42px, 42px, "call.png");
        position: relative;
        display: inline-block;
        margin: 40px 10px;
        vertical-align: top;
      }
    }
    .phone-call:hover {
      background-image: url(img/call-btn.png);
    }
  }
}

.cameraBlock {
  .el-switch {
    margin-top: -5px !important;
    margin-left: -8px !important;
  }
}

.mode3dBlock {
  .el-switch {
    margin-top: -5px !important;
    margin-left: -8px !important;
  }
}
</style>
<style scoped lang="scss">
// 该页面都是经过rotate旋转 位置属性也需在脑海中旋转后调试

.carInfo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  position: absolute;
  transform: rotate(270deg);
  right: 625px;
  top: 660px;
  @include bg-box(419px, 254px, "carInfo.png");
  padding-top: 29px;
  &.out {
    animation-name: show;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
  }
  .typeName {
    height: 34px;
    font-size: 30px;
    font-weight: 600;
    color: #ffffff;
    line-height: 34px;
    margin-bottom: 25px;
  }
  .typeName2 {
    height: 30px;
    font-size: 30px;
    color: #ffffff;
    line-height: 30px;
    margin-bottom: 15px;
    span {
      color: rgba(75, 224, 255, 1);
      font-weight: 500;
    }
  }
}

.mode3dBlock {
  /*position: absolute;
  left: 240px;
  transform: scale(2.5) rotate(270deg);
  font-weight: bolder;
  top: 1650px;
  z-index: 99;*/
  position: absolute;
  left: 334px;
  transform: scale(1.8) rotate(270deg);
  font-weight: bolder;
  top: 1560px;
  z-index: 99;

  span {
    display: inline-block !important;
    font-size: 17px !important;
  }
}

.cameraBlock {
  /*position: absolute;
  left: 240px;
  transform: scale(2.5) rotate(270deg);
  font-weight: bolder;
  top: 1650px;
  z-index: 99;*/
  position: absolute;
  left: 270px;
  transform: scale(1.8) rotate(270deg);
  font-weight: bolder;
  top: 1560px;
  z-index: 99;

  span {
    display: inline-block !important;
    font-size: 17px !important;
  }
}

.camera {
  position: absolute;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 50px;
  z-index: 99;
  height: 50px;
  background-image: url("./img/camera.png");
  background-size: 100% 100%;

  span {
    background: radial-gradient(black, transparent);
    display: block;
    position: relative;
    margin-top: 50px;
    font-size: 22px;
    font-weight: bolder;
    width: 90px;
    text-align: center;
    margin-left: -40px;
  }
}

.bg_58 {
  width: 906px;
  height: 910px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("img/road_58.png");
  background-size: 100% 100%;
  position: absolute;
  left: 5%;
  top: 28%;
  transform: rotate(262.5deg) scale(1.05);
}

.bg_89 {
  width: 1081px;
  height: 1921px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("img/road_89.png");
  background-size: 100% 100%;
  position: absolute;
  left: 4.3%;
  top: 5.7%;
  transform: rotate(97.5deg) scale(0.95);
}
.bg {
  width: 100%;
  height: 100%;
  @include bg-box(100%, 100%, "road.png");
  position: absolute;
  left: 4.3%;
  top: 6.7%;
  transform: rotate(97.5deg) scale(1.05);
  //@include bg-box(100%, 100%, "allmap.png");
}

.door1 {
  width: 75px;
  height: 40px;
  @include bg-box(75px, 40px, "door.png");
  position: absolute;
  top: 808px;
  left: 165px;
  transform: rotate(271deg);
}

.door2 {
  width: 75px;
  height: 40px;
  @include bg-box(75px, 40px, "door.png");
  position: absolute;
  top: 1080px;
  left: 160px;
  transform: rotate(271.5deg);
}

.door3 {
  width: 75px;
  height: 40px;
  @include bg-box(75px, 40px, "door.png");
  position: absolute;
  top: 1250px;
  left: 157px;
  transform: rotate(271.5deg);
}

.door4 {
  width: 75px;
  height: 40px;
  @include bg-box(75px, 40px, "door.png");
  position: absolute;
  top: 1354px;
  left: 323px;
  transform: rotate(179deg);
}

.door5 {
  width: 75px;
  height: 40px;
  @include bg-box(75px, 40px, "door.png");
  position: absolute;
  top: 1353px;
  left: 778px;
  transform: rotate(179deg);
}

.colorScreen_inner {
  pointer-events: all;
}

.colorScreen_container {
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;
  margin-left: -50px;

  .weatherBar {
    width: 493px;
    height: 784px;
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: -20%;
    left: 33%;
    transform: scale(1) rotate(-90deg);
    .weatherBox {
      width: 406px;
      height: 183px;
      background: url("./img/左1.png") no-repeat;
      background-size: cover;
      margin-bottom: 30px;
      .wbItem {
        display: flex;
        height: 90px;
        line-height: 90px;
        text-align: center;
        .wbTitle {
          width: 40%;
          font-size: 28px;
          color: rgba(71, 255, 221, 1);
        }
        .wbValue {
          width: 58%;
          display: flex;
          > :nth-child(1) {
            font-size: 40px;
            width: 60%;
            color: rgba(153, 245, 255, 1);
          }
          > :nth-child(2) {
            font-size: 24px;
            width: 40%;
            color: rgba(228, 228, 228, 1);
          }
        }
      }
    }
    .weatherBox2 {
      width: 406px;
      height: 95px;
      background: url("./img/左2.png") no-repeat !important;
    }
  }
  .roadLegend {
    width: 400px;
    height: 300px;
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 15%;
    left: 10%;
    transform: scale(1) rotate(-90deg);
    .rlItem {
      width: 250px;
      height: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      > :nth-child(1) {
        width: 120px;
        height: 20px;
        border-radius: 30px;
      }
      > :nth-child(2) {
        font-size: 24px;
        letter-spacing: 3px;
        font-weight: bolder;
      }
    }
    .clean {
      :nth-child(1) {
        background: #65fdca;
      }
    }
    .ligthDiary {
      :nth-child(1) {
        background: #65c1fd;
      }
    }
    .Diary {
      :nth-child(1) {
        background: #fde665;
      }
    }
  }
  .road-idx {
    position: absolute;
    top: 30px;
    left: 40px;
    color: #65c1fd !important;
    border: 2px solid #65c1fd;
    text-align: center;
    line-height: 35px;
    height: 40px;
    border-radius: 40px;
    width: 40px;
    font-size: 22px;
    font-weight: bolder;
  }

  .roadTooltips {
    display: flex;
    position: absolute;
    padding: 2% 1.5%;
    top: 2%;
    left: 13.4%;
    transform: scale(0.8);
    .roadItem {
      width: 494px;
      height: 196px;
      display: flex;
      flex-direction: column;
      background: url("./img/右.png") no-repeat;
      background-size: cover;
      transform: scale(1.2) rotate(-90deg);
      font-size: 28px;
      margin-left: -235px;
      .rttTop {
        padding-top: 22px;
        height: 70%;
        text-align: center;
        > :nth-child(1) {
          color: rgba(71, 255, 221, 1);
        }
        > :nth-child(2) {
          color: rgba(153, 245, 255, 1);
        }
      }
      .rttBottom {
        height: 30%;
        display: flex;
        > div {
          width: 50%;
          text-align: center;
        }
        :nth-child(1) {
          color: rgba(71, 255, 221, 1);
        }
        :nth-child(2) {
          &.clean {
            color: #65fdca;
          }
          &.ligthDiary {
            color: #65c1fd;
          }
          &.Diary {
            color: #fde665;
          }
        }
      }
    }
  }
  .map58Container {
    position: absolute;
    width: 906px;
    height: 910px;
    background-position: center;
    background-repeat: no-repeat;
    // background-image: url(./img/map.png);
    background-size: cover;
    //left: 12%;
    left: 5%;
    top: 28%;
    //transform: rotate(160.5deg) scale(1.05);
    transform: rotate(262.5deg) scale(1.05);
  }
  .map89Container {
    background-size: cover;
    width: 1081px;
    height: 1921px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 4.3%;
    top: 5.7%;
    transform: rotate(97.5deg) scale(0.95);
  }
  .mapContainer {
    position: absolute;
    top: 360px;
    left: -268px;
    right: 0px;
    bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    // background-image: url(./img/map.png);
    background-size: cover;
    transform: rotate(98deg) scale(0.72);
  }
  .roadVdm150 {
    width: 40px;
    height: 40px;
    background: url("./img/vdm.png") no-repeat;
    background-size: cover;
    position: absolute;
    transform: rotate(-90deg);
    &.pos1 {
      left: 610px;
      top: 760px;
    }
    &.pos2 {
      left: 720px;
      top: 1050px;
    }
    &.pos3 {
      left: 830px;
      top: 760px;
    }
  }
  .vdmChart {
    padding: 60px 10px;
    width: 1200px;
    height: 700px;
    transform: rotate(-90deg);
    position: absolute;
    left: -150px;
    top: 750px;
    z-index: 99;
    background: black;
    background-color: rgba(7, 13, 13, 0.9);
    // background: url("./img/roadvdm2.png") no-repeat;
    background-size: cover;
    border: 3px solid rgba(50, 152, 223, 0.9);
    .vcTitle {
      position: absolute;
      top: 20px;
      left: 30px;
      font-size: 38px;
    }
    .vcClose {
      position: absolute;
      top: 20px;
      right: 30px;
      width: 60px;
      height: 32px;
      background: url(/static/img/popupImg/closeBtn.png) no-repeat;
    }
  }
}
.plus-icon-enter-active {
  transition: opacity 1s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 1s;
}
.plus-icon-leave-to {
  opacity: 0;
}
</style>
